export default __webpack_public_path__ + "static/media/premium-icon.4ff27ace.svg";